module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_AnthologyTitles"
  }, [_c('span')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Page_Break"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing__And__Page_Break"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-family": "'Old English Text MT'",
      "font-size": "6.00em"
    }
  }, [_vm._v("Dragonesque")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')])])]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')])])]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')])])]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')])])]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.83em"
    }
  }, [_vm._v("Edited by")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')])])]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.83em"
    }
  }, [_vm._v("S.C. Butler")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.83em"
    }
  }, [_vm._v("&")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing__OPENPAR_1_CLOSEPAR_"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.83em"
    }
  }, [_vm._v("Joshua Palmatier")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.83em"
    }
  }, [_vm._v("Zombies Need Brains LLC")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')])])]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span', [_c('span', {
    staticStyle: {
      "font-size": "0.83em"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.zombiesneedbrains.com",
      "target": "_blank"
    }
  }, [_vm._v("www.zombiesneedbrains.com")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "P_Normal__And__Centre_Alignment"
  }, [_c('div', {
    staticClass: "B_Box1",
    staticStyle: {
      "display": "inline-block",
      "margin-left": "auto",
      "margin-right": "auto"
    }
  }, [_c('p', {
    staticClass: "P_Normal__And__Centre_Alignment__And__Line_Spacing"
  }, [_c('span')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3541d17e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0003.vue
// module id = 66
// module chunks = 0